import { Request } from '../request';
import { IBasicInfoStep, ILicense, IProfessionalProfile, IBackgroundInfo } from 'types/newUniprofile';
import { Physician } from 'types/common';
import { IInsurance } from 'types/insurance';

export const getBasicInfo = () => Request.get({ url: '/schedule-server/provider/uniprofile/basic/info/detail' });

export const getLicense = () => Request.get({ url: '/schedule-server/provider/uniprofile/license/list' });

export const getInsurance = () => Request.get({ url: '/schedule-server/provider/uniprofile/insurance/detail' });

export const getProfessionalProfile = () => Request.get({ url: '/schedule-server/provider/uniprofile/professional/detail' });

export const getBackground = () => Request.get({ url: '/schedule-server/provider/uniprofile/background/detail' });

export const editBasicInfo = (data: IBasicInfoStep) => Request.post({ url: '/schedule-server/provider/uniprofile/basic/info/save', params: data });

export const editIdentification = (data: ILicense) => Request.post({ url: '/schedule-server/provider/uniprofile/license/save/batch', params: data });

export const editInsurance = (data: IInsurance) => Request.post({ url: '/schedule-server/provider/uniprofile/insurance/save', params: data });

export const editProfessionalProfile = (data: IProfessionalProfile) => Request.post({ url: '/schedule-server/provider/uniprofile/professional/save', params: data });

export const editBackground = (data: IBackgroundInfo) => Request.post({ url: '/schedule-server/provider/uniprofile/background/save', params: data });

export const editCollaboratingPhysician = (data: Physician[]) => Request.post({ url: '/schedule-server/physician/update/batch', params: data });
